
































































































































































































































































































































































import {
  Component, Vue, Watch, Prop,
} from 'vue-property-decorator';
import AddIcon from 'mdi-vue/Plus';

import StatusIndicator from '@/components/StatusIndicator.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Loader from '@/components/Loader.vue';
import Select from '@/components/Select.vue';
import FormInput from '@/components/FormInput.vue';
import Button from '@/components/Button.vue';
import Checkbox from '@/components/Checkbox.vue';
import numberFormat from '@/libs/numberFormat';
import Toggle from '@/components/Toggle.vue';

@Component({
  components: {
    StatusIndicator,
    LayoutContent,
    Loader,
    Select,
    FormInput,
    Button,
    Checkbox,
    AddIcon,
    Toggle,
  },
  methods: {
    numberFormat,
  },
})
export default class BillingFields extends Vue {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  @Prop({ type: Object, default: {} }) readonly value!: BillingFieldsModel;
  @Prop(String) phase!: string;

  billingTypes = [
    { label: 'Normal', value: 'normal' },
    { label: 'MDR', value: 'mdr' },
    { label: 'Tiering per Traffic', value: 'tiring' },
    { label: 'Tiering per Amount', value: 'tiring_amount' },
    { label: 'Mixed', value: 'mixed' },
  ];

  BussinessModels = [
    { label: 'Direct Bundling', value: '0' },
    { label: 'Direct Non Bundling', value: '1' },
    { label: 'Escrow', value: '2' },
  ];

  loading = false;
  bussinessType = this.value.bussinessType || '';
  transactionFeeType = this.value.transactionFeeType || '';
  transactionFeeValue = this.value.transactionFeeValue || '';
  feeBank = this.value.feeBank || '';
  includePPN = this.value.includePPN;
  statusBill = this.value.statusBill;
  bussinessModel = this.value.bussinessModel || '';
  description = this.value.description || '';
  environment = process.env.VUE_APP_ENVIRONMENT || '';
  live = this.value.live;

  get inputVal() {
    return this.value;
  }

  @Watch('value', { deep: true })
  onChangeProp() {
    this.bussinessType = this.value.bussinessType === '' ? 'B2C' : this.value.bussinessType;
    this.transactionFeeType = this.value.transactionFeeType;
    this.feeBank = this.value.feeBank;
    this.includePPN = this.value.includePPN;
    this.statusBill = this.value.statusBill;
    this.bussinessModel = this.value.bussinessModel;
    this.description = this.value.description;
    this.transactionFeeValue = this.value.transactionFeeValue;
    this.live = this.value.live;
  }

  @Watch('bussinessType')
  @Watch('transactionFeeType')
  @Watch('transactionFeeValue')
  @Watch('feeBank')
  @Watch('includePPN')
  @Watch('statusBill')
  @Watch('bussinessModel')
  @Watch('description')
  @Watch('live')
  onChange() {
    const {
      bussinessType,
      transactionFeeType,
      transactionFeeValue,
      feeBank,
      includePPN,
      statusBill,
      bussinessModel,
      description,
      live,
    } = this;

    this.$emit('input', {
      bussinessType,
      transactionFeeType,
      transactionFeeValue,
      feeBank,
      includePPN,
      statusBill,
      bussinessModel,
      description,
      live,
    });
  }

  @Watch('transactionFeeType')
  onFeeTypeChange(val: { label: string; value: string }, oldVal: { label: string; value: string }) {
    if (val.value === oldVal.value) return;

    if ((val.value === 'tiring_amount' || val.value === 'tiring') && typeof this.transactionFeeValue === 'string') {
      this.transactionFeeValue = [{
        min: '0', max: '0', type: 'Normal', price: '0',
      }];
    } else if ((val.value === 'mixed') && typeof this.transactionFeeValue === 'string') {
      this.transactionFeeValue = { normal: '0', mdr: '0' };
    } else if ((val.value === 'normal' || val.value === 'mdr') && typeof this.transactionFeeValue !== 'string') {
      this.transactionFeeValue = '0';
    }
  }

  addTier() {
    this.transactionFeeValue = [...this.tierList, {
      min: '0', max: '0', type: 'Normal', price: '0',
    }];
  }

  deleteTier(index: number) {
    const current = this.tierList.slice();
    current.splice(index, 1);
    this.transactionFeeValue = current;
  }

  get tierList() {
    return this.transactionFeeValue as Tier[];
  }

  get mixedPrice() {
    return this.transactionFeeValue as MixedPricing;
  }
}
